import Image from "@Components/Image";
import { BASE_IMG_URL } from "constants/configConstants";
import styles from "./HeroImageHolder.module.scss";
import { useSelector } from "react-redux";
import { AppState } from "@Store/index";
import wrapperHOC from "@Utils/wrapperHOC";

const HeroImageContainer = () => {
  const { isUserLoggedIn } = useSelector(({ appData }: AppState) => ({
    isUserLoggedIn: appData.isUserLoggedIn,
  }));
  return (
    <div>
      <Image
        src={`${BASE_IMG_URL}referralv2Character.png`}
        height={460}
        width={460}
        alt="Hero Image"
        className={
          isUserLoggedIn ? styles.heroImageContainer : styles.heroImageContainerUnauthenticated
        }
      />
    </div>
  );
};

export default wrapperHOC(HeroImageContainer, {
  componentName: "HeroImageContainer-ReferralDesktop",
  showForChina: true,
});
